// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';

export { AcrCard } from './AcrCard';

const acrCard = EntityCardBlueprint.make({
  name: 'acr',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { AcrCard } = await import('./AcrCard');
      return <AcrCard />;
    },
  },
});

export const acrCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [acrCard],
});
